<template>
  <div class="dizme_tm_mobile_menu">
    <div class="mobile_menu_inner">
      <div class="mobile_in">
        <div class="logo">
          <a href="#"
            ><img :src="`img/logo/${dark ? 'dark' : 'logo'}.png`" alt=""
          /></a>
        </div>
        <div class="trigger" @click="activeToggle()">
          <div
            class="hamburger hamburger--slider"
            :class="active ? 'is-active' : ''"
          >
            <div class="hamburger-box">
              <div class="hamburger-inner"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown" :style="{ display: active ? 'block' : 'none' }">
      <div class="dropdown_inner">
        <ul class="anchor_nav">
          <li class="current"><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#features">Features</a></li>
          <li><a href="#pricing">Pricing</a></li>
          <li v-if="canReopenDonorProAccess()">
            <a href="#donor-pro-access" @click.prevent="reopenDonorProAccess()"
              >Free Pro</a
            >
          </li>
          <li><a href="#apps">Mobile Apps</a></li>
          <li><a href="https://app.mypbe.com/demo">Try Demo</a></li>
          <li><a href="https://app.mypbe.com/login">Login</a></li>
          <li class="download_cv">
            <a href="https://app.mypbe.com/register"><span>Get Started</span></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  canReopenDonorProAccess,
  openDonorProAccess,
} from "@/donorProAccess";

export default {
  name: "MobileHeader",
  data() {
    return {
      active: false,
    };
  },
  methods: {
    activeToggle() {
      this.active = !this.active;
    },
    /**
     * Only appears once the announcement has been dismissed, so the item is a
     * way back rather than a second copy of the same nag.
     *
     * Kept as an `<a>` inside the `<li>` on purpose: `utilits.scroll_` reads
     * `li.getElementsByTagName("a")[0].getAttribute("href")` for every
     * `.anchor_nav li` on each scroll event, and an item without one would
     * throw all the way through the scroll-spy. The href names no section for
     * the same reason — a bare "#" equals the `#${current}` it builds when no
     * section is active, which would mark this item as the current one.
     */
    canReopenDonorProAccess,
    /** The dropdown stays open over the modal otherwise. */
    reopenDonorProAccess() {
      this.active = false;
      openDonorProAccess();
    },
  },
  props: {
    dark: { type: Boolean },
  },
};
</script>
